import React, { Component }          from 'react';

import icLink                        from '../../img/ic_link.svg';
import icMail                        from '../../img/ic_mail.svg';
import icSearch                      from '../../img/ic_magnify.svg';
import icMore                        from '../../img/ic_more.svg';
import icLeftArrow                   from '../../img/ic_left_arrow.svg';
import icRightArrow                  from '../../img/ic_right_arrow.svg';

import "./Admins.scss";

class Recordings extends Component {

  constructor(props) {
    super(props);

    this.state            = {
    }
  }

  hasSearchParams() {
    return this.props.searchParams && Object.keys(this.props.searchParams).length > 0;
  }

  showMoreMenu(i) {
    this.setState({moreMenuIndex: i})
  }

  showDeleteRecording(admin) {
    this.dismissMoreMenu();
  }

  dismissMoreMenu() {
    this.setState({moreMenuIndex: -1})
  }

  renderLineItems() {
    let itemsToRender = this.hasSearchParams() ? this.props.searchResults : this.props.recordings;
    let lineItems = [];

    if (!itemsToRender) {
      itemsToRender = [];
    }

    for (let i = 0; i < itemsToRender.length; i++) {
      lineItems.push(
        <div className="line-item" key={i}>
            <div className="fields">
              <div className="field large">{itemsToRender[i].email}</div>
              <div className="field">{new Date(itemsToRender[i].createdAt).toLocaleString()}</div>
              <div className="field">{itemsToRender[i].firstName}</div>
              <div className="field">{itemsToRender[i].Location ? itemsToRender[i].Location.name : ''}</div>
              <div className="field small">{itemsToRender[i].optInToEmailUpdates === true ? 'YES' : 'NO'}</div>
            </div>
            <div className="icons">
              <a target='_blank' className="visible" href={`/#/recordings/download?key=${itemsToRender[i].url}`}><img src={icLink} /></a>
              <img onClick={() => this.showMoreMenu(i)} src={icMore} />
              <div className={`more-menu ${this.state.moreMenuIndex === i ? 'show' : ''}`}>
                <div onClick={() => {
                  this.dismissMoreMenu()
                  this.props.showDeleteRecordingDialog(itemsToRender[i])
                }} className="item">Delete Recording</div>
                <div onClick={() => {
                  this.dismissMoreMenu()
                  this.props.showResendRecordingDialog(itemsToRender[i])
                }} className="item">Resend Email Link</div>
              </div>
            </div>
        </div>
      );
    }
    return lineItems;
  }

  renderSearchItem(key, searchResult) {
    if (key === "email") {
      return `Email: ${searchResult}`;
    } else if (key === "startDate") {
      return `Start: ${new Date(searchResult).toLocaleString()}`
    } else if (key === "endDate") {
      return `End: ${new Date(searchResult).toLocaleString()}`
    } else if (key === "locationId") {
      const location = this.props.locations.find(location => location.id === parseInt(searchResult))
      if (location) {
        return `Location: ${location.name}`;
      }
    } else {
      return ""
    }
  }

  renderSearchParams() {
    const searchParamList = [];
    const searchParamKeys = Object.keys(this.props.searchParams);
    for (let i = 0; i < searchParamKeys.length; i++) {
      const key = searchParamKeys[i];
      searchParamList.push(<div className="param">
        { `${this.renderSearchItem(key, this.props.searchParams[key])} ${i < searchParamKeys.length - 1 ? ',' : ''}` }
      </div>);
    }
    return <div className="params">{searchParamList}</div>;
  }

  downloadSearchResultCSV() {
    let searchQuery = "";
    const params = Object.keys(this.props.searchParams)
    for (let i = 0; i < params.length; i++) {
      if (i !== params.length - 1) {
        searchQuery += `${params[i]}=${this.props.searchParams[params[i]]}&`
      } else {
        searchQuery += `${params[i]}=${this.props.searchParams[params[i]]}`
      }
    }
    this.props.downloadCSVFile(`/api/recordings/download_csv?${searchQuery}`)
  }

  renderSearchHeader() {
    if (this.hasSearchParams()) {
      return <div className="search-header">
        <div className="results">
          Search Params: { this.renderSearchParams() }
        </div>
        <div className="buttons">
          <div onClick={this.props.clearSearchParams} className="clear">CLEAR</div>
          <div onClick={this.props.showExportRecordingsDialog} className="clear">Export to Zip</div>
          <div onClick={() => this.downloadSearchResultCSV()} className="clear">Download Results CSV</div>
        </div>
      </div>
    }
  }
  
  renderPagingNumbers() {
    const pageSize = 8;
    if (this.hasSearchParams()) {
      const firstItem = this.props.searchPage * pageSize + 1;
      const lastItem = firstItem + pageSize >= this.props.maxSearchResults ? this.props.maxSearchResults : firstItem + pageSize - 1; 
      return `${firstItem}-${lastItem} of ${this.props.maxSearchResults}`;
    } else {
      const firstItem = this.props.currentPage * pageSize + 1;
      const lastItem = firstItem + pageSize >= this.props.maxResults ? this.props.maxResults : firstItem + pageSize - 1; 
      return `${firstItem}-${lastItem} of ${this.props.maxResults}`;
    }
  }

  canDecrementPage() {
    if (this.hasSearchParams()) {
      return this.props.searchPage === 0;
    } else {
      return this.props.currentPage === 0;
    }
  }

  onLocationChange(event) {
    this.props.setLocationFilter(event.target.value)
  }

  canIncrementPage() {
    if (this.hasSearchParams()) {
      return (this.props.searchPage + 1)*8 >= this.props.maxSearchResults;
    } else {
      return (this.props.currentPage + 1)*8 >= this.props.maxResults;
    }
  }

  renderLocations() {
    return <select className={`${this.hasSearchParams() ? 'hide' : 'show'}`} onChange={this.onLocationChange.bind(this)} value={this.props.locationFilter}>
      <option value={-1} key="0">All Locations</option>
      {this.props.locations.map((l, i) => {
        return <option key={i + 1} value={l.id}>{l.name}</option>
      })}
    </select>
  }

  renderDownloadButton() {
    if (this.props.locationFilter !== undefined && this.props.locationFilter > -1 && !this.hasSearchParams()) {
      return <div onClick={() => this.props.downloadCSVFile(`/api/locations/${this.props.locationFilter}/download_csv`)} className="menu-button">
        Download CSV
      </div>
    }
  }

  render() {
    return (
      <div className={`admins__container ${this.props.currentState === "RECORDINGS" ? 'show' : ''}`}>
        { this.renderSearchHeader()}
        <div className="filter-bar">
          {this.renderLocations()}
          <div className="group">
            { this.renderDownloadButton() }
            <img onClick={() => this.props.showSearchDialog()} src={icSearch}/>
          </div>
        </div>
        <div className="line-item-header">
          <div className="column-names">
            <div className="name large">Email</div>
            <div className="name">Register Date</div>
            <div className="name">First Name</div>
            <div className="name">Location</div>
            <div className="name small">Opted In</div>
            <div className="mobile-name">RECORDINGS</div>
          </div>
          <div className="icons">
            <div className="paging">
              <img className={`${this.canDecrementPage() ? 'disable' : 'enable'}`} onClick={() => this.props.decrementPage("RECORDINGS")} src={icLeftArrow}/>
              <div className="page-numbers">{this.renderPagingNumbers()}</div>
              <img className={`${this.canIncrementPage() ? 'disable' : 'enable'}`} onClick={() => this.props.incrementPage("RECORDINGS")} src={icRightArrow}/>
            </div>
          </div>
        </div>
        <div className="line-items-container">
          <div className="line-items">
            { this.renderLineItems() }
          </div>
        </div>
        <div onClick={this.dismissMoreMenu.bind(this)} className={`more-menu-click-target ${this.state.moreMenuIndex >= 0 ? 'show' : ''}`}></div>
      </div>
    );
  }
}

export default Recordings;